import React, { useContext, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { AuthContext, ThemeContext } from "../../auth";
import { useMediaQuery } from "react-responsive";
import {
  ChartBar,
  ChartDonutCustomer,
  ChartDonutProduct,
  ChartLine,
  ChartLineSolution,
  HeaderWeb,
  SidebarComponent,
  TableLeadDark,
  TableLeadLight,
  TabsPcpPenjualanDark,
  TabsPcpPenjualanLight,
  TabsPcpSewaDark,
  TabsPcpSewaLight,
  UserInformationProgress,
} from "../../components";
import {
  Card,
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Tab,
  Tabs,
} from "react-bootstrap";
import GaugeChart from "react-gauge-chart";
import Swal from "sweetalert2";
import { TableLeadSpv } from "../../components/Table";
import { axiosAuth } from "../../api";

function DashboardByUser() {
  const { id } = useParams();
  const { theme } = useContext(ThemeContext);
  const { showSidebar, accessToken } = useContext(AuthContext);
  const isMobile = useMediaQuery({ maxWidth: 1024 });
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { data } = location.state || {};
  const [monthlyLead, setMonthlyLead] = useState({});
  const [userInformation, setUserInformation] = useState({});

  const retrieveMonthlyLead = () => {
    setLoading(true);
    axiosAuth
      .get(`/api/analytics/barchart?userId=${id}`, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          withCredentials: true,
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        setMonthlyLead(res?.data?.data);

        setLoading(false);
      })
      .catch((err) => {
        console.error(err);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Gagal memuat data, coba kembali beberapa saat lagi!",
        });

        setLoading(false);
      });
  };

  const retrieveUserInformation = () => {
    setLoading(true);
    axiosAuth
      .get(`/api/analytics/information?userId=${id}`, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          withCredentials: true,
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        setUserInformation(res?.data?.data);

        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (accessToken !== undefined && id !== undefined) retrieveMonthlyLead();
    if (accessToken !== undefined && id !== undefined)
      retrieveUserInformation();
  }, [accessToken, id]);

  const successRate =
    userInformation?.totalSuccessLeadYearly && userInformation?.totalLeadYearly
      ? (userInformation.totalSuccessLeadYearly /
          userInformation.totalLeadYearly) *
        100
      : 0;

  const chartStyle = {
    fontFamily: "Roboto-Bold",
    marginTop: "30px",
    marginBottom: "30px",
  };

  const [listLead, setListLead] = useState([]);
  const [averageLead, setAverageLead] = useState(0);

  const retrieveLead = () => {
    setLoading(true);
    axiosAuth
      .get(`/api/leads?userId=${id}`, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          withCredentials: true,
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        const filteredData = res.data.data.filter(
          (item) => item.status != 100 && item.status != 0,
        );

        setListLead(filteredData);

        if (filteredData.length > 0) {
          const totalStatus = filteredData.reduce(
            (sum, item) => sum + item.status,
            0,
          );
          const avg = totalStatus / filteredData.length;
          setAverageLead(Math.round(avg));
        } else {
          setAverageLead(0);
        }

        setLoading(false);
      })
      .catch((err) => {
        console.error(err);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Gagal memuat data, coba kembali beberapa saat lagi!",
        });

        setLoading(false);
      });
  };

  useEffect(() => {
    if (accessToken !== undefined && id !== undefined) retrieveLead();
  }, [accessToken, id]);

  const [selectedDate, setSelectedDate] = useState("");

  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");

  const maxDate = `${year}-${month}`;

  const formStyles = {
    label: {
      fontFamily: "Poppins-Medium",
      color: theme === "light" ? "#FFFFFF" : "#222222",
    },
    input: {
      color: theme === "light" ? "#FFFFFF" : "#222222",
      backgroundColor: theme === "light" ? "#282828" : "#FFFFFF",
      fontFamily: "Poppins-Regular",
      height: "3.2rem",
      borderColor: "#b4b4b4ff",
    },
  };

  return (
    <div
      style={{
        overflowX: "hidden",
        maxWidth: "100vw",
        backgroundColor: theme === "light" ? "#121212" : "#FFFFFF",
        transition: "0.8s",
      }}
    >
      <SidebarComponent />
      <div
        className="mb-3"
        style={{
          backgroundColor: theme === "light" ? "#121212" : "#FFFFFF",
          width: isMobile
            ? "100%"
            : `calc(100% - ${showSidebar ? "78px" : "190px"})`,
          marginLeft: isMobile ? "0px" : showSidebar ? "78px" : "190px",
          transition: "0.8s",
        }}
      >
        <Row>
          <Col xs={6} lg={6} className="text-start">
            <h4
              className="ms-4 pt-4"
              style={{
                fontFamily: "Poppins-Medium",
                fontSize: isMobile ? "20px" : "38px",
                color: theme === "light" ? "#FFFFFF" : "",
                marginBottom: "0px",
              }}
            >
              Dashboard {data?.firstName + " " + data?.lastName}
            </h4>
          </Col>
          <Col
            xs={6}
            lg={6}
            className={
              isMobile === false ? "text-end my-auto" : "text-end my-auto pt-4"
            }
          >
            <HeaderWeb />
          </Col>
        </Row>
      </div>
      <div
        id={theme === "light" ? "containerAppDark" : "containerAppLight"}
        style={{
          width: isMobile
            ? "100%"
            : `calc(100% - ${showSidebar ? "78px" : "190px"})`,
          marginLeft: isMobile ? "0px" : showSidebar ? "78px" : "190px",
          transition: "0.8s",
        }}
      >
        <div className={isMobile ? "mx-2" : "ms-3 pt-3 me-1"}>
          <div style={{ marginTop: isMobile ? "20px" : "20px" }}>
            <Row>
              <Col xs={12} lg={8}>
                <Card
                  className={isMobile ? "w-100" : " w-100"}
                  style={{
                    backgroundColor: theme === "light" ? "#282828" : "#FFFFFF",
                    borderRadius: "10px",
                    height: "100%",
                  }}
                >
                  <Card.Body>
                    <ChartLine id={id} accessToken={accessToken} />
                  </Card.Body>
                </Card>
              </Col>
              <Col xs={12} lg={4} className={isMobile ? "mt-4" : ""}>
                <Card
                  className={isMobile ? "" : "mx-2"}
                  style={{
                    backgroundColor: theme === "light" ? "#282828" : "#FFFFFF",
                    borderRadius: "10px",
                    height: "100%",
                  }}
                >
                  <Card.Body className="text-center">
                    <p
                      className="ps-1 py-2 text-start"
                      style={{
                        marginBottom: "0px",
                        marginTop: "0px",
                        fontFamily: "Poppins-Bold",
                        fontSize: "20px",
                        color: theme === "light" ? "#FFFFFF" : "#222",
                      }}
                    >
                      Success Rate
                    </p>
                    <GaugeChart
                      style={chartStyle}
                      hideText={true}
                      percent={successRate / 100}
                      colors={
                        theme === "light"
                          ? [
                              "#9ed1e4ff",
                              "#82c6dfff",
                              "#55bfe6ff",
                              "#3db5e0ff",
                              "#12B3ED",
                            ]
                          : [
                              "#5C9EFF",
                              "#5590f3",
                              "#3c77e0",
                              "#1c5fc8",
                              "#0047AB",
                            ]
                      }
                      nrOfLevels={5}
                      needleColor={theme === "light" ? "white" : "#acacac"}
                      needleBaseColor={theme === "light" ? "white" : "#acacac"}
                    />
                    <p
                      className="mt-4 text-center"
                      style={{
                        fontFamily: "Poppins-Bold",
                        fontSize: "20px",
                        color: theme === "light" ? "#FFFFFF" : "#222",
                      }}
                    >
                      {successRate.toFixed(2) + "%"}
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col>
                <Card
                  className={isMobile ? "w-100" : "me-2"}
                  style={{
                    backgroundColor: theme === "light" ? "#282828" : "#FFFFFF",
                    borderRadius: "10px",
                    height: "100%",
                  }}
                >
                  <Card.Body>
                    <ChartLineSolution id={id} accessToken={accessToken} />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row
              className={`${isMobile ? "mt-2" : "my-3"} d-flex align-items-stretch`}
            >
              <Col xs={12} lg={4} className="mt-3">
                <UserInformationProgress
                  userInformation={userInformation}
                  averageLead={averageLead}
                  id={id}
                  accessToken={accessToken}
                  selectedDate={selectedDate}
                />
              </Col>
              <Col xs={12} lg={8} className="mt-3">
                <Card
                  className={isMobile ? "w-100" : "me-2"}
                  style={{
                    backgroundColor: theme === "light" ? "#282828" : "#FFFFFF",
                    borderRadius: "10px",
                    height: "100%",
                  }}
                >
                  <Card.Body>
                    <ChartBar monthlyLead={monthlyLead} />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row className="me-2 mt-4">
              <Col lg={4}>
                <Form.Control
                  data-bs-theme={theme === "light" ? "dark" : ""}
                  type="month"
                  onChange={(e) => setSelectedDate(e.target.value)}
                  value={selectedDate}
                  style={formStyles.input}
                  max={maxDate}
                  required
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col xs={12} lg={6} className="mt-3 d-flex">
                <Card
                  className={isMobile ? "w-100" : "w-100"}
                  style={{
                    backgroundColor: theme === "light" ? "#282828" : "#FFFFFF",
                    borderRadius: "10px",
                    height: "100%",
                  }}
                >
                  <Card.Body>
                    <ChartDonutCustomer
                      id={id}
                      accessToken={accessToken}
                      selectedDate={selectedDate}
                    />
                  </Card.Body>
                </Card>
              </Col>
              <Col xs={12} lg={6} className="mt-3 d-flex">
                <Card
                  className={isMobile ? "w-100" : "w-100"}
                  style={{
                    backgroundColor: theme === "light" ? "#282828" : "#FFFFFF",
                    borderRadius: "10px",
                    height: "100%",
                  }}
                >
                  <Card.Body>
                    <ChartDonutProduct
                      id={id}
                      accessToken={accessToken}
                      selectedDate={selectedDate}
                    />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <br />
            <br />
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "200px" }}
              >
                <Spinner
                  animation="border"
                  style={{ color: theme === "light" ? "#F3C623" : "#2f4b7c" }}
                />
              </div>
            ) : (
              <>
                {
                  <div className={isMobile ? "mt-4" : "me-2"}>
                    <TableLeadSpv
                      listLead={listLead}
                      name={data?.firstName + " " + data?.lastName}
                    />
                  </div>
                }
              </>
            )}
          </div>
          <br />
          <br />
        </div>
      </div>
    </div>
  );
}

export default DashboardByUser;
